import { partial_ratio, token_set_ratio } from 'fuzzball'

/** Minimum trimmed query length before weak-match YouTube CTA is considered (reduces flicker while typing). */
export const CATALOG_MATCH_MIN_QUERY_LEN = 3

/**
 * Top catalog hit fuzzy scores below this (0–100, fuzzball) are treated as low-confidence for YouTube fallback UX.
 * Tunable via QA; not related to Convex BM25.
 */
export const CATALOG_MATCH_WEAK_THRESHOLD = 72

function rowScore (query, target) {
  if (!query || !target) return 0
  return Math.max(
    partial_ratio(query, target),
    token_set_ratio(query, target)
  )
}

/**
 * Best fuzzball similarity (0–100) of `query` against a song's title, artist, and combined string.
 * @param {string} query
 * @param {{ title?: string, artist?: string }} song
 * @returns {number}
 */
export function catalogTopMatchScore (query, song) {
  const q = (query ?? '').trim()
  if (!q || !song) return 0

  const title = (song.title ?? '').trim()
  const artist = (song.artist ?? '').trim()
  const combined = [title, artist].filter(Boolean).join(' ')

  let best = 0
  if (title) best = Math.max(best, rowScore(q, title))
  if (artist) best = Math.max(best, rowScore(q, artist))
  if (combined) best = Math.max(best, rowScore(q, combined))

  return best
}

/**
 * @param {string} query
 * @param {{ title?: string, artist?: string }} song
 * @returns {boolean}
 */
export function isWeakCatalogTopMatch (query, song) {
  if ((query ?? '').trim().length < CATALOG_MATCH_MIN_QUERY_LEN) return false
  return catalogTopMatchScore(query, song) < CATALOG_MATCH_WEAK_THRESHOLD
}
